import { useContext, useEffect, useState } from 'react';

//api
import { generateRecoveryCodeForUser } from '@/api/orgSettings/passkeys';

//context
import { OrgSettingsUsersContext } from '@/context/OrgSettingsUsersContext';

//interfaces
import { NotificationStatus } from  '@/interfaces/languages';
import { useTimer } from  '@/components/hooks/utility/useTimer';



const UseCreateCodeModal = (showModal:boolean, onGenerateClick: ()=> void) => {
    const {userId} = useContext(OrgSettingsUsersContext);
    const [generatedCode, setGeneratedCode] = useState<string|undefined>(undefined);
    const [notificationDetails, setNotificationDetails] = useState<{show: boolean, status: NotificationStatus | null, message: string}>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (showModal) {
            cleanUp();
        }
    }, [showModal]);

    useTimer(notificationDetails?.show ?? false, ()=>setNotificationDetails({show: false, status:null, message: ""}), 3000);
    
    function onConfirmClick() {
        setIsLoading(true);
        generateCode();
    }

    function generateCode() {
        generateRecoveryCodeForUser(userId)
        .then(({code}) => {
            setGeneratedCode(code);
        })
        .catch(() => {
            setNotificationDetails({show: true, status: NotificationStatus.error, message: "Unable to generate a code at this time. Please try again."});
        })
        .finally(() => {
            onGenerateClick();
            setIsLoading(false);
        });
    }

    function cleanUp(){
        setGeneratedCode(undefined);
    }

    return {
        generatedCode,
        onConfirmClick,
        isLoading,
        notificationDetails
    }
}

export default UseCreateCodeModal;